import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketService } from '../../../shared/services/market.service';
import { Auth } from 'aws-amplify';
import { MatDialog } from "@angular/material/dialog";
import { ConfirmComponent } from "../../components/dialog/confirm/confirm.component";
import { Observable } from 'rxjs';

@Component({ 
  selector: 'app-edit-property',
  templateUrl: './edit-property.component.html',
  styleUrls: ['./edit-property.component.css']
})
export class EditPropertyComponent implements OnInit {

  recievedProperty: any;
  editPropertyForm: FormGroup;
  customStylesValidated = false;
  isLoading: boolean = false;
  loading: boolean = false;
  display: boolean = false;
  owner: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private marketService: MarketService,
    public dialog: MatDialog,) {
    this.getCurrentAuthenticatedUser(); 
    this.editPropertyForm = this.fb.group({
      name: ['', [Validators.required]],
      status: ['', [Validators.required]],
      type: ['', [Validators.required]],
      industry: ['', [Validators.required]],
      noOfDays: ['', [Validators.required]],
      onSiteAttendance: ['', [Validators.required]],
      eventSite: ['', [Validators.required]],
      category: ['', [Validators.required]],
      description: ['', [Validators.required]]
    });
  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.route.queryParams.subscribe(params => {

      console.log("recieved property: ", params);
      this.recievedProperty = params;

    });

    const formValues = {
      name: [this.recievedProperty.name],
      status: [this.recievedProperty.status],
      type: [this.recievedProperty.type],
      industry: [this.recievedProperty.industry],
      noOfDays: [this.recievedProperty.noOfDays],
      onSiteAttendance: [this.recievedProperty.onSiteAttendance],
      eventSite: [this.recievedProperty.eventSite],
      category: [this.recievedProperty.category],
      description: [this.recievedProperty.description]
    };

    setTimeout(() => {
      this.isLoading = false;
      this.editPropertyForm = this.fb.group(formValues);
    }, 1000);
      //populate form with current values
  }

  onEditNewProperty() {
    this.customStylesValidated = true;
    if (this.editPropertyForm.valid) {
      
      const dialogRef = this.dialog.open(ConfirmComponent, {
        width: '26.5rem',
        data: { 
          dialogTitle: 'Confirmation', 
          dialogMessageLine1: 'Are you sure want to edit this Property?',
          yesButtonText: 'Yes',
          noButtonText: 'No'
        }
      });
    
      dialogRef.afterClosed().subscribe(result => {
        if ( !!result ) {
          //  this.deleteEmployee( id );
          console.log('Yes');
          // this.onDeleteProperty(property);
          this.loading = true;

          const editedProperty = this.editPropertyForm.value;
          editedProperty['propertyId'] = this.recievedProperty.propertyId;
          editedProperty['owner'] = this.owner; 
          console.log("updatedProperty: ", editedProperty)
    
          this.marketService.editProperty(editedProperty).subscribe((data) => {
            console.log("Success: ", data);
            setTimeout(() => {
              this.loading = false;
              this.router.navigate(['private-space/view-properties', {}]);
            }, 1000); 
          }, (error) => {
            this.loading = false;
            console.log("Error: ", error);
    
          });
        }
      });

    } else {
      this.display = true;
    }

  }

}
